import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnnonymousSidebarComponent } from './annonymous-sidebar.component';
import { LanguageSelectComponent } from '@app/shared';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { GapFixerIphoneComponent } from '@app/layout/shared/gap-fixer-iphone/gap-fixer-iphone.component';

@NgModule({
  declarations: [AnnonymousSidebarComponent],
  imports: [
    CommonModule,
    LanguageSelectComponent,
    LocalizeRouterModule,
    RouterModule,
    NgbCollapseModule,
    TranslateModule,
    GapFixerIphoneComponent,
  ],
  exports: [AnnonymousSidebarComponent],
})
export class AnnonymousSidebarModule {}
